<template>
    <div>
        <div class="container d-md-none" v-if="!hidemenu">
            <nav class="navbar navbar-expand navbar-dark fixed-bottom bg-dark border-top border-light px-1">
                <div class="navbar-brand">
                    <img src="/favicon.ico" width="32px"/>
                </div>
                <ul class="nav navbar-nav">
                    <li class="nav-item" v-if="loggedIn">
                        <router-link tag="a" :to="{name: 'bet'}" :replace="true" class="nav-link">Tippen</router-link>
                    </li>
                    <li class="nav-item" v-if="loggedIn">
                        <router-link tag="a" :to="{name: 'round'}" class="nav-link h-100">Liga</router-link>
                    </li>
                    <li class="nav-item" v-if="loggedIn">
                        <router-link tag="a" to="/team" class="nav-link">Team</router-link>
                    </li>
                </ul>
                <router-link v-if="!loggedIn && $route.name!=='login'"
                             :to="{name: 'login'}"
                             replace
                             tag="button"
                             class="me-3 ms-auto btn btn-outline-light">
                    Anmelden
                </router-link>
                <span class="text-light ms-auto me-0" @click="subMenuVisible = !subMenuVisible">
                    <fas icon="bars"></fas>
                </span>
            </nav>
            <div class="submenu bg-dark border border-light p-0 text-end" v-if="subMenuVisible"
                 v-on-clickaway="hideSubMenu">
                <div class="submenu-header small text-secondary text-end mt-1 me-1 pe-2">Tippen</div>
                <router-link tag="div" :to="{name: 'specialBets'}" class="nav-link submenu-item">Sondertipps
                </router-link>
                <!--
                <div class="dropdown-divider m-0"></div>
                <div class="submenu-header small text-secondary text-end mt-1 me-1 pe-2">Team</div>
                <router-link tag="div" to="/transfermarket" class="nav-link submenu-item">Taktik</router-link>
                -->
                <div class="dropdown-divider m-0"></div>
                <div class="submenu-header small text-secondary text-end mt-1 me-1 pe-2">Transfermarkt</div>
                <router-link tag="div" to="/transfermarkt" class="nav-link submenu-item">Transferliste</router-link>
                <router-link v-if="team" tag="div" :to="'/kader/' + team.id" class="nav-link submenu-item">Kader
                </router-link>
                <div class="dropdown-divi der m-0"></div>
                <router-link tag="div" to="/shop" class="nav-link submenu-item">Offizieller Shop</router-link>
                <router-link tag="div" to="/impressum" class="nav-link submenu-item">Impressum/Datenschutz</router-link>
                <div class="nav-link submenu-item" @click="switchToDesktop">Desktop-Version</div>
                <div class="nav-link submenu-item" @click="logout">Abmelden</div>
            </div>
        </div>


        <!-- Menu, um Navigation zwischen alter und neuer UI zu erlauben -->
        <div id="legacy-header" class="d-none d-md-block">
            <div class="d-block justify-content-center mx-auto">
                <div id="legacy-status" v-if="loggedIn">
                    <b>
                        <user class="ps-1" :data="user" :show-team="false"/>
                    </b>
                    <span class="ps-1 align-middle">{{ balance | kies }}</span>
                    |
                    <team-emblem v-if="isCoach" class="mx-1" :emblem-id="user.team.emblemId" size="21" />
                    <b v-if="isCoach">{{ user.team.name }}</b>
                    <div class="d-inline-flex ms-2 link btn-sakali border border-dark rounded"
                         style="padding: 0.2em; vertical-align: middle;"
                         @click="logout">
                        <fas icon="power-off"/>
                    </div>
                </div>
            </div>
            <div id="legacy-menu" class="d-flex mx-auto">
                <a href="https://forum.sandkastenliga.de" class="legacy-main-menu-item"
                   :class="{'legacy-main-menu-item-inactive': !isSection('forum'),
                         'legacy-main-menu-item-active': isSection('forum')}">
                    Forum
                </a>
                <a :href="baseUrl + '/coachdetail.html'" class="legacy-main-menu-item"
                   :class="{'legacy-main-menu-item-inactive': !isSection('coach'),
                        'legacy-main-menu-item-active': isSection('coach')}">
                    Trainer
                </a>
                <a :href="baseUrl + '/groupdetail.html'" class="legacy-main-menu-item"
                   :class="{'legacy-main-menu-item-inactive': !isSection('round'),
                    'legacy-main-menu-item-active': isSection('round')}">
                    Spiele
                </a>
                <a :href="baseUrl + '/teamdetail.html'" class="legacy-main-menu-item"
                   :class="{'legacy-main-menu-item-inactive': !isSection('team'),
                    'legacy-main-menu-item-active': isSection('team')}">
                    Mannschaft
                </a>
                <a v-if="betweenSeasons"
                   :href="baseUrl + '/transfermarkt'"
                   class="legacy-main-menu-item"
                   :class="{'legacy-main-menu-item-inactive': !isSection('transfer'),
                    'legacy-main-menu-item-active': isSection('transfer')}">
                    Transfermarkt
                </a>
                <a :href="baseUrl + '/halloffame.html'" class="legacy-main-menu-item"
                   :class="{'legacy-main-menu-item-inactive': !isSection('awards'),
                    'legacy-main-menu-item-active': isSection('awards')}">
                    Trophäenkammer
                </a>
                <a :href="baseUrl + '/spa/tippschein'" class="legacy-main-menu-item"
                   :class="{'legacy-main-menu-item-inactive': !isSection('bet'),
                         'legacy-main-menu-item-active': isSection('bet')}">
                    Tippen
                </a>
                <a :href="baseUrl + '/spa/shop'" class="legacy-main-menu-item"
                   :class="{'legacy-main-menu-item-inactive': !isSection('shop'),
                         'legacy-main-menu-item-active': isSection('shop')}">
                    Shop
                </a>
            </div>
            <div id="legacy-sub-menu" class="d-flex">
                <div v-if="isSection('bet')">
                  <router-link tag="span" :to="{name: 'bet'}" class="legacy-sub-menu-item"
                               :class="{'legacy-sub-menu-item-active':isRoute('bet')}">
                    Tippschein
                  </router-link>
                  <router-link tag="span" :to="{name: 'specialBets'}" class="legacy-sub-menu-item"
                               :class="{'legacy-sub-menu-item-active':isRoute('specialBets')}">
                    Sondertipps
                  </router-link>
                  <router-link tag="span" :to="{name: 'betPeriodResults'}" class="legacy-sub-menu-item"
                               :class="{'legacy-sub-menu-item-active':isRoute('betPeriodResults')}">
                    Tipprunde
                  </router-link>
                  <router-link tag="span" :to="{name: 'betSeasonResults'}" class="legacy-sub-menu-item"
                               :class="{'legacy-sub-menu-item-active':isRoute('betSeasonResults')}">
                    Rangliste
                  </router-link>
                </div>
            </div>
            <!-- Ende Legacy Menu -->
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {mixin as clickaway} from 'vue-clickaway';
import WECTeaserLinkMixin from "@/components/wec/WECTeaserLinkMixin";
import User from "@/components/user/User.vue";

export default {
    components: {User},
    data() {
        return {
            subMenuVisible: false,
            hidemenu: false,
        }
    },
    computed: {
        ...mapGetters(['loggedIn', 'user', 'team', 'betweenSeasons', 'isCoach']),
        baseUrl() {
            return process.env.VUE_APP_SANDKASTENLIGA_BASE_URL
        },
        balance() {
            if (this.loggedIn)
                return this.user.balance + (this.transientBalanceAdjustment ? this.transientBalanceAdjustment : 0)
            else
                return 0
        }
    },
    methods: {
        ...mapActions(['logoutAction']),
        logout() {
            this.logoutAction().then(() => this.$router.push({name: 'login'}))
        },
        hideSubMenu() {
            this.subMenuVisible = false
        },
        switchToDesktop() {
            window.open(this.baseUrl)
        },
        isSection(name) {
            return this.$route.meta.section == name
        },
        isRoute(name) {
            return this.$route.name == name
        },
    },
    beforeMount() {
        if (this.$route.query.hidemenu)
            this.hidemenu = this.$route.query.hidemenu
    },
    mixins: [clickaway, WECTeaserLinkMixin]
}
</script>

<style>
.submenu {
    position: fixed;
    bottom: 46px;
    right: 5px;
    z-index: 1040;
}

.submenu-item {
    padding-right: 0.7rem !important;
    padding-top: 0.2rem !important;
    cursor: pointer;
    color: white;
}

.submenu-item:hover {
    color: #FF9900;
}

.submenu-header {
    text-transform: uppercase;
}

#legacy-header {
    font-family: sans-serif;
    align-items: center;
}

#legacy-status {
    height: 26px;
    width: 1024px;
    background: #C3C3C3;
    color: #333333;
    font-size: 11px;
    padding-top: 0.2em;
    padding-right: 7px;
    margin: auto;
    text-align: right;
}

#legacy-menu {
    display: flex;
    background-image: url('https://sandkastenliga.de/img/new_headline.gif');
    background-repeat: no-repeat;
    background-position-y: top;
    height: 105px;
    width: 1024px;
    padding-left: 130px;
    font-weight: bold;
}

.legacy-main-menu-item {
    font-size: 11px;
    margin-top: 73px;
    padding-top: 8px;
    padding-left: 12px;
    padding-right: 12px;
    color: #85A600;
    vertical-align: bottom;
    border-left: 1px solid #85A600;
    border-right: 1px solid #85A600;
    border-top: 1px solid #85A600;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}

.legacy-main-menu-item-active {
    color: #FF9900;
    background-image: linear-gradient(#FCFFEA, #F0FFAC);
}

.legacy-main-menu-item-inactive {
    background-color: #F0FFAC;
    border-bottom: 0.12em solid #85A600;;
}

.legacy-main-menu-item:hover {
    cursor: pointer;
    text-decoration: none;
    color: #FF9900;
}

#legacy-sub-menu {
    display: flex;
    height: 28px;
    width: 1024px;
    margin: auto;
    background: #F0FFAC;
    padding-left: 124px;
    padding-top: 6px;
    font-size: 11px;
    font-weight: bold;
    border-bottom: 1px solid #85A600;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}

.legacy-sub-menu-item {
    color: #85A600;
    padding-left: 8px;
    padding-right: 8px;
    border-right: 1px solid #85A600;
}

.legacy-sub-menu-item-active {
    color: #FF9900;
}

.legacy-sub-menu-item:hover {
    cursor: pointer;
    color: #FF9900;
    text-decoration: none;
}


</style>
